<template>
  <article id="login">
    <div class="container">
      <img id="logo" alt="FINNOMENA" src="../assets/logo.png" />
      <p>version {{ version }}</p>
      <div>{{message}}</div>
      <div class="button" @click="login">
        <i class="fas fa-sign-in-alt"></i>Sign In
      </div>
      <div class="button" @click="logout">
        <i class="fas fa-sign-out-alt"></i>Sign Out
      </div>
    </div>
  </article>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      location: null,
      message: null,
      version: process.env.VUE_APP_VERSION
    };
  },
  metaInfo: {
    title: "Login to FINNOMENA"
  },
  components: {},
  props: { userID: String, env: Object, finnakies: String },
  async mounted() {
    await this.islogin();
  },
  methods: {
    login: function() {
      window.location = "/login";
    },
    logout: async function() {
      window.location = "/logout";
    },
    islogin: async function() {
      try {
        await axios.post(`/auth/private`);
        this.message = "You are logged in";
      } catch (err) {
        this.message = "You are not log in";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#login {
  padding: 5%;

  .container {
    width: 100%;
    text-align: center;

    .button {
      border-radius: 4px;
      margin: 10px;
      padding: 20px;
      background-color: $color-primary-finno;
      flex-direction: row;
      vertical-align: middle;
      cursor: pointer;

      i {
        margin-right: 6px;
      }
    }
  }
}
</style>




